import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createProfileAction } from "../../../redux/actions/profile.actions";
import BasicProfileForm from "../BasicProfileForm";
import PhoneNumberFormPanel from "../PhoneNumberFormPanel";
import FaxNumberFormPanel from "../FaxNumberFormPanel";
import EmailAddressFormPanel from "../EmailAddressFormPanel";
import WebAddressFormPanel from "../WebAddressFormPanel";
import SocialFormPanel from "../SocialFormPanel";
import ContactsFormPanel from "../ContactsFormPanel";
import AddressFormPanel from "../AddressFormPanel/AddressFormPanel";
import "./styles.scss";

export class CreateProfileForm extends Component {
  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit(values =>
          this.props.createProfileAction(this.props.slug, values)
        )}
      >
        <h3 className="modal-title text-center">Create Profile</h3>
        <br />
        <BasicProfileForm />
        <hr />
        <PhoneNumberFormPanel />
        <hr />
        <FaxNumberFormPanel />
        <hr />
        <EmailAddressFormPanel />
        <hr />
        <AddressFormPanel />
        <hr />
        <WebAddressFormPanel />
        <hr />
        <SocialFormPanel />
        <hr />
        <ContactsFormPanel />
        <hr />
        <div className="row justify-content-end">
          <div className="col-auto">
            <button
              type="submit"
              id="update-profile-btn"
              disabled={!this.props.valid}
              className="btn btn-primary"
            >
              Save
            </button>
          </div>
        </div>
        <br />
      </form>
    );
  }
}

export default reduxForm({
  validate: values => {
    const errors = {};

    if (!values.first_name) {
      errors.first_name = "Enter a first name";
    }

    if (!values.last_name) {
      errors.last_name = "Enter a last name";
    }

    if (!values.email) {
      errors.email = "Enter an email address";
    }

    if (!values.addresses || !values.addresses.length >= 1) {
      // Check that at lease one address has a city and country

      if (!values.addresses[0].city_district) {
        errors.city_district = "Enter a city";
      }

      if (!values.addresses[0].country) {
        errors.country = "Enter a country";
      }

    }
    return errors;
  },
  form: "EditProfileForm"
})(
  connect(
    null,
    { createProfileAction }
  )(CreateProfileForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/CreateProfileForm/CreateProfileForm.jsx